/* eslint-disable max-len */
import React, { useState } from 'react';
import MoreInformation from '../../../Components/CompanyMoreInformationTooltip';
import { PriceHandler } from '../../../redux/helper/CamelCase';
import { CDN } from '../../../constants';

export default function DistributorDetails({ OrderDetails, handleNotifyUser }) {
    const [hoverId, sethoverId] = useState(false);
    const handleImage = (img) => (img !== undefined ? `${CDN}/${img}` : '/images/profile_picture_user_icon_153847.png');

    return (
        <div className="pt-3 px-2.5 pb-2 border border-[#CBC7C7] rounded-lg bg-[#F5F5FA] flex">
            <div className="w-2/3 pr-3.5 border-r border-[#CBC7C7]">
                <h5 className="text-xs2 font-semibold text-[#000000]">Distributor/Customer Details</h5>
                <div className="mt-1 flex items-center">
                    <div>
                        <img src={handleImage(OrderDetails.distributor_info.profile_image_url)} alt="icon" loading="lazy" decoding="async" style={{ borderRadius: '50%', height: '55px', width: '55px' }} />
                    </div>
                    <div className="pl-3.5">
                        {(OrderDetails.distributor_info.FIRST_NAME || OrderDetails.distributor_info.LAST_NAME) === null
                            ? (
                                <p className="text-base font-semibold text-[#303030]" data-testid="dist-name">
                                    {OrderDetails.distributor_info.PARTY_NAME}

                                </p>
                            )
                            : (
                                <p className="text-base font-semibold text-[#303030]" data-testid="dist-name">
                                    {OrderDetails.distributor_info.FIRST_NAME}
                                    {' '}
                                    {OrderDetails.distributor_info.LAST_NAME}
                                </p>
                            )}

                        <p className="text-xs13 font-normal text-[#555259]" data-testid="dist-code">{OrderDetails?.distributor_id}</p>
                    </div>
                </div>
                <div className="flex -mx-0.5 mt-2.5">
                    <div className="w-1/2 px-0.5">
                        <p className="text-xs3 font-semibold text-[#808285]">Mobile Number</p>
                        <p className="pt-1 text-sm font-normal text-[#090406]">
                            +91
                            {' '}
                            {OrderDetails?.distributor_info?.PRIMARY_PHONE_NUMBER}
                        </p>
                    </div>
                    <div className="w-1/2 px-0.5">
                        <p className="text-xs3 font-semibold text-[#808285]">Email Address</p>
                        <p className="pt-1 text-sm font-normal text-[#090406] break-words">{OrderDetails?.distributor_info?.EMAIL_ADDRESS}</p>
                    </div>
                </div>
                <div className="flex -mx-0.5 mt-1.5">
                    <div className="w-3/5 px-0.5">
                        <p className="text-xs3 font-semibold text-[#808285]">Company Name</p>
                        <p className="pt-1 text-sm font-normal text-[#090406] br/eak-words">{OrderDetails?.distributor_company_name}</p>
                    </div>
                    <div className="w-2/5 px-0.5 flex items-center self-end pb-1 relative">
                        <p className="text-xs3 font-semibold text-[#808285]">More Details</p>
                        <button
                            onMouseEnter={() => {
                                setTimeout(() => {
                                    sethoverId('selected');
                                }, 1000);
                            }}
                            onMouseLeave={() => {
                                setTimeout(() => {
                                    sethoverId('');
                                }, 2000);
                            }}
                            className="pl-1"
                            data-tooltip-target="moreDetails"
                            data-tooltip-placement="left"
                            data-tooltip-trigger="hover"
                            type="button"
                        >
                            <img src="/images/info_icon-gray.svg" alt="icon" className="cursor-pointer" />
                        </button>
                        {hoverId && <MoreInformation OrderDetails={OrderDetails.distributor_info} />}
                    </div>
                </div>
            </div>
            <div className="w-1/3 pl-2.5">
                <h5 className="text-xs2 font-semibold text-[#000000]">Credit</h5>
                <div className="mt-[18px]">
                    <p className="text-xs3 font-semibold text-[#808285]">Credit Limit</p>
                    <p className="pt-1 text-sm font-normal text-[#090406]">{PriceHandler(OrderDetails?.distributor_info?.ADOR_CASH_BALANCE || 0)}</p>
                </div>
                <div className="mt-3">
                    <p className="text-xs3 font-semibold text-[#808285]">Outstanding Amount</p>
                    <p className="pt-1 text-sm font-normal text-[#090406]">{PriceHandler(OrderDetails?.distributor_info?.OUTSTANDING_AMT || 0)}</p>
                </div>
                { ['Trade', 'Trade EUB'].includes(OrderDetails?.order_type) && (
                    <button onClick={() => handleNotifyUser()} type="button" className="rounded-lg border border-[#6E1417] py-1.5 bg-[#FFE8E9] text-xs12 font-semibold text-[#6E1417] w-[86px] mt-2">
                        Notify User
                    </button>
                )}
            </div>
        </div>
    );
}
